export default {
    // Dutch
    nl: {
        nationalities: {
            default: 'Selecteer een nationaliteit',
            LU: 'Luxemburg',
            BE: 'België',
            BG: 'Bulgarije',
            CY: 'Cyprus',
            DK: 'Denemarken',
            DE: 'Duitsland',
            EE: 'Estland',
            FI: 'Finland',
            FR: 'Frankrijk',
            GR: 'Griekenland',
            HU: 'Hongarije',
            IE: 'Ierland',
            IT: 'Italië',
            HR: 'Kroatië',
            LV: 'Letland',
            LT: 'Litouwen',
            MT: 'Malta',
            NL: 'Nederland',
            AT: 'Oostenrijk',
            PL: 'Polen',
            PT: 'Portugal',
            RO: 'Roemenië',
            SI: 'Slovenië',
            SK: 'Slowakije',
            ES: 'Spanje',
            CZ: 'Tsjechië',
            SE: 'Zweden',
            CH: 'Zwitserland',
            AF: 'Afghanistan',
            AL: 'Albanië',
            DZ: 'Algerije',
            AS: 'Amerikaans-Samoa',
            VI: 'Amerikaanse Maagdeneilanden',
            AD: 'Andorra',
            AO: 'Angola',
            AI: 'Anguilla',
            AQ: 'Antarctica',
            AG: 'Antigua en Barbuda',
            AR: 'Argentinië',
            AM: 'Armenië',
            AW: 'Aruba',
            AU: 'Australië',
            AZ: 'Azerbeidzjan',
            BS: 'Bahama\'s',
            BH: 'Bahrein',
            BD: 'Bangladesh',
            BB: 'Barbados',
            BZ: 'Belize',
            BJ: 'Benin',
            BM: 'Bermuda',
            BT: 'Bhutan',
            BO: 'Bolivia',
            BQ: 'Bonaire Sint Eustatius en Saba',
            BA: 'Bosnië en Herzegovina',
            BW: 'Botswana',
            BV: 'Bouveteiland',
            BR: 'Brazilië',
            IO: 'Brits Indische Oceaanterritorium',
            VG: 'Britse Maagdeneilanden',
            BN: 'Brunei',
            BF: 'Burkina Faso',
            BI: 'Burundi',
            KH: 'Cambodja',
            CA: 'Canada',
            CF: 'Centraal-Afrikaanse Republiek',
            CL: 'Chili',
            CN: 'China',
            CX: 'Christmaseiland',
            CC: 'Cocoseilanden',
            CO: 'Colombia',
            KM: 'Comoren',
            CG: 'Congo-Brazzaville',
            CD: 'Congo-Kinshasa',
            CK: 'Cookeilanden',
            CR: 'Costa Rica',
            CU: 'Cuba',
            CW: 'Curaçao',
            DJ: 'Djibouti',
            DM: 'Dominica',
            DO: 'Dominicaanse Republiek',
            EC: 'Ecuador',
            EG: 'Egypte',
            SV: 'El Salvador',
            GQ: 'Equatoriaal-Guinea',
            ER: 'Eritrea',
            ET: 'Ethiopië',
            FO: 'Faeröer',
            FK: 'Falklandeilanden',
            FJ: 'Fiji',
            PH: 'Filipijnen',
            GF: 'Frans-Guyana',
            PF: 'Frans-Polynesië',
            TF: 'Franse Zuidelijke en Antarctische Gebieden',
            GA: 'Gabon',
            GM: 'Gambia',
            GE: 'Georgië',
            GH: 'Ghana',
            GI: 'Gibraltar',
            GD: 'Grenada',
            GL: 'Groenland',
            GP: 'Guadeloupe',
            GU: 'Guam',
            GT: 'Guatemala',
            GG: 'Guernsey',
            GN: 'Guinee',
            GW: 'Guinee-Bissau',
            GY: 'Guyana',
            HT: 'Haïti',
            HM: 'Heard en McDonaldeilanden',
            HN: 'Honduras',
            HK: 'Hongkong',
            IS: 'IJsland',
            IN: 'India',
            ID: 'Indonesië',
            IQ: 'Irak',
            IR: 'Iran',
            IL: 'Israël',
            CI: 'Ivoorkust',
            JM: 'Jamaica',
            JP: 'Japan',
            YE: 'Jemen',
            JE: 'Jersey',
            JO: 'Jordanië',
            KY: 'Kaaimaneilanden',
            CV: 'Kaapverdië',
            CM: 'Kameroen',
            KZ: 'Kazachstan',
            KE: 'Kenia',
            KG: 'Kirgizië',
            KI: 'Kiribati',
            UM: 'Kleine afgelegen eilanden van de Verenigde Staten',
            KW: 'Koeweit',
            LA: 'Laos',
            LS: 'Lesotho',
            LB: 'Libanon',
            LR: 'Liberia',
            LY: 'Libië',
            LI: 'Liechtenstein',
            MO: 'Macau',
            MK: 'Macedonië',
            MG: 'Madagaskar',
            MW: 'Malawi',
            MV: 'Maldiven',
            MY: 'Maleisië',
            ML: 'Mali',
            IM: 'Man',
            MA: 'Marokko',
            MH: 'Marshalleilanden',
            MQ: 'Martinique',
            MR: 'Mauritanië',
            MU: 'Mauritius',
            YT: 'Mayotte',
            MX: 'Mexico',
            FM: 'Micronesia',
            MD: 'Moldavië',
            MC: 'Monaco',
            MN: 'Mongolië',
            ME: 'Montenegro',
            MS: 'Montserrat',
            MZ: 'Mozambique',
            MM: 'Myanmar',
            NA: 'Namibië',
            NR: 'Nauru',
            NP: 'Nepal',
            NI: 'Nicaragua',
            NC: 'Nieuw-Caledonië',
            NZ: 'Nieuw-Zeeland',
            NE: 'Niger',
            NG: 'Nigeria',
            NU: 'Niue',
            KP: 'Noord-Korea',
            MP: 'Noordelijke Marianen',
            NO: 'Noorwegen',
            NF: 'Norfolk',
            UG: 'Oeganda',
            UA: 'Oekraïne',
            UZ: 'Oezbekistan',
            OM: 'Oman',
            TL: 'Oost-Timor',
            PK: 'Pakistan',
            PW: 'Palau',
            PA: 'Panama',
            PG: 'Papoea-Nieuw-Guinea',
            PY: 'Paraguay',
            PE: 'Peru',
            PN: 'Pitcairneilanden',
            PR: 'Puerto Rico',
            QA: 'Qatar',
            RU: 'Rusland',
            RW: 'Rwanda',
            RE: 'Réunion',
            KN: 'Saint Kitts en Nevis',
            LC: 'Saint Lucia',
            VC: 'Saint Vincent en de Grenadines',
            BL: 'Saint-Barthélemy',
            PM: 'Saint-Pierre en Miquelon',
            SB: 'Salomonseilanden',
            WS: 'Samoa',
            SM: 'San Marino',
            ST: 'Sao Tomé en Principe',
            SA: 'Saoedi-Arabië',
            SN: 'Senegal',
            RS: 'Servië',
            SC: 'Seychellen',
            SL: 'Sierra Leone',
            SG: 'Singapore',
            SX: 'Sint Maarten',
            SH: 'Sint-Helena Ascension en Tristan da Cunha',
            MF: 'Sint-Maarten',
            SD: 'Soedan',
            SO: 'Somalië',
            SJ: 'Spitsbergen en Jan Mayen',
            LK: 'Sri Lanka',
            SR: 'Suriname',
            SZ: 'Swaziland',
            SY: 'Syrië',
            TJ: 'Tadzjikistan',
            TW: 'Taiwan',
            TZ: 'Tanzania',
            TH: 'Thailand',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trinidad en Tobago',
            TD: 'Tsjaad',
            TN: 'Tunesië',
            TR: 'Turkije',
            TM: 'Turkmenistan',
            TC: 'Turks- en Caicoseilanden',
            TV: 'Tuvalu',
            UY: 'Uruguay',
            VU: 'Vanuatu',
            VA: 'Vaticaanstad',
            VE: 'Venezuela',
            GB: 'Verenigd Koninkrijk',
            AE: 'Verenigde Arabische Emiraten',
            US: 'Verenigde Staten van Amerika',
            VN: 'Vietnam',
            WF: 'Wallis en Futuna',
            EH: 'Westelijke Sahara',
            BY: 'Wit-Rusland',
            ZM: 'Zambia',
            ZW: 'Zimbabwe',
            ZA: 'Zuid-Afrika',
            GS: 'Zuid-Georgia en de Zuidelijke Sandwicheilanden',
            KR: 'Zuid-Korea',
            SS: 'Zuid-Soedan',
            AX: 'Åland',
        },
    },
    // English
    en: {
        nationalities: {
            default: 'Select a nationality',
            LU: 'Luxembourg',
            BE: 'Belgium',
            BG: 'Bulgaria',
            CY: 'Cyprus',
            DK: 'Denmark',
            DE: 'Germany',
            EE: 'Estonia',
            FI: 'Finland',
            FR: 'France',
            GR: 'Greece',
            HU: 'Hungary',
            IE: 'Ireland',
            IT: 'Italy',
            HR: 'Croatia',
            LV: 'Latvia',
            LT: 'Lithuania',
            MT: 'Malta',
            NL: 'Netherlands',
            AT: 'Austria',
            PL: 'Poland',
            PT: 'Portugal',
            RO: 'Romania',
            SI: 'Slovenia',
            SK: 'Slovakia',
            ES: 'Spain',
            CZ: 'Czechia',
            SE: 'Sweden',
            CH: 'Switzerland',
            AF: 'Afghanistan',
            AL: 'Albania',
            DZ: 'Algeria',
            AS: 'American Samoa',
            VI: 'U.S. Virgin Islands',
            AD: 'Andorra',
            AO: 'Angola',
            AI: 'Anguilla',
            AQ: 'Antarctica',
            AG: 'Antigua & Barbuda',
            AR: 'Argentina',
            AM: 'Armenia',
            AW: 'Aruba',
            AU: 'Australia',
            AZ: 'Azerbaijan',
            BS: 'Bahamas',
            BH: 'Bahrain',
            BD: 'Bangladesh',
            BB: 'Barbados',
            BZ: 'Belize',
            BJ: 'Benin',
            BM: 'Bermuda',
            BT: 'Bhutan',
            BO: 'Bolivia',
            BQ: 'Caribbean Netherlands',
            BA: 'Bosnia & Herzegovina',
            BW: 'Botswana',
            BV: 'Bouvet Island',
            BR: 'Brazil',
            IO: 'British Indian Ocean Territory',
            VG: 'British Virgin Islands',
            BN: 'Brunei',
            BF: 'Burkina Faso',
            BI: 'Burundi',
            KH: 'Cambodia',
            CA: 'Canada',
            CF: 'Central African Republic',
            CL: 'Chile',
            CN: 'China',
            CX: 'Christmas Island',
            CC: 'Cocos (Keeling) Islands',
            CO: 'Colombia',
            KM: 'Comoros',
            CG: 'Congo - Brazzaville',
            CD: 'Congo - Kinshasa',
            CK: 'Cook Islands',
            CR: 'Costa Rica',
            CU: 'Cuba',
            CW: 'Curaçao',
            DJ: 'Djibouti',
            DM: 'Dominica',
            DO: 'Dominican Republic',
            EC: 'Ecuador',
            EG: 'Egypt',
            SV: 'El Salvador',
            GQ: 'Equatorial Guinea',
            ER: 'Eritrea',
            ET: 'Ethiopia',
            FO: 'Faroe Islands',
            FK: 'Falkland Islands',
            FJ: 'Fiji',
            PH: 'Philippines',
            GF: 'French Guiana',
            PF: 'French Polynesia',
            TF: 'French Southern Territories',
            GA: 'Gabon',
            GM: 'Gambia',
            GE: 'Georgia',
            GH: 'Ghana',
            GI: 'Gibraltar',
            GD: 'Grenada',
            GL: 'Greenland',
            GP: 'Guadeloupe',
            GU: 'Guam',
            GT: 'Guatemala',
            GG: 'Guernsey',
            GN: 'Guinea',
            GW: 'Guinea-Bissau',
            GY: 'Guyana',
            HT: 'Haiti',
            HM: 'Heard & McDonald Islands',
            HN: 'Honduras',
            HK: 'Hong Kong SAR China',
            IS: 'Iceland',
            IN: 'India',
            ID: 'Indonesia',
            IQ: 'Iraq',
            IR: 'Iran',
            IL: 'Israel',
            CI: 'Côte d’Ivoire',
            JM: 'Jamaica',
            JP: 'Japan',
            YE: 'Yemen',
            JE: 'Jersey',
            JO: 'Jordan',
            KY: 'Cayman Islands',
            CV: 'Cape Verde',
            CM: 'Cameroon',
            KZ: 'Kazakhstan',
            KE: 'Kenya',
            KG: 'Kyrgyzstan',
            KI: 'Kiribati',
            UM: 'U.S. Outlying Islands',
            KW: 'Kuwait',
            LA: 'Laos',
            LS: 'Lesotho',
            LB: 'Lebanon',
            LR: 'Liberia',
            LY: 'Libya',
            LI: 'Liechtenstein',
            MO: 'Macao SAR China',
            MK: 'North Macedonia',
            MG: 'Madagascar',
            MW: 'Malawi',
            MV: 'Maldives',
            MY: 'Malaysia',
            ML: 'Mali',
            IM: 'Isle of Man',
            MA: 'Morocco',
            MH: 'Marshall Islands',
            MQ: 'Martinique',
            MR: 'Mauritania',
            MU: 'Mauritius',
            YT: 'Mayotte',
            MX: 'Mexico',
            FM: 'Micronesia',
            MD: 'Moldova',
            MC: 'Monaco',
            MN: 'Mongolia',
            ME: 'Montenegro',
            MS: 'Montserrat',
            MZ: 'Mozambique',
            MM: 'Myanmar (Burma)',
            NA: 'Namibia',
            NR: 'Nauru',
            NP: 'Nepal',
            NI: 'Nicaragua',
            NC: 'New Caledonia',
            NZ: 'New Zealand',
            NE: 'Niger',
            NG: 'Nigeria',
            NU: 'Niue',
            KP: 'North Korea',
            MP: 'Northern Mariana Islands',
            NO: 'Norway',
            NF: 'Norfolk Island',
            UG: 'Uganda',
            UA: 'Ukraine',
            UZ: 'Uzbekistan',
            OM: 'Oman',
            TL: 'Timor-Leste',
            PK: 'Pakistan',
            PW: 'Palau',
            PA: 'Panama',
            PG: 'Papua New Guinea',
            PY: 'Paraguay',
            PE: 'Peru',
            PN: 'Pitcairn Islands',
            PR: 'Puerto Rico',
            QA: 'Qatar',
            RU: 'Russia',
            RW: 'Rwanda',
            RE: 'Réunion',
            KN: 'St. Kitts & Nevis',
            LC: 'St. Lucia',
            VC: 'St. Vincent & Grenadines',
            BL: 'St. Barthélemy',
            PM: 'St. Pierre & Miquelon',
            SB: 'Solomon Islands',
            WS: 'Samoa',
            SM: 'San Marino',
            ST: 'São Tomé & Príncipe',
            SA: 'Saudi Arabia',
            SN: 'Senegal',
            RS: 'Serbia',
            SC: 'Seychelles',
            SL: 'Sierra Leone',
            SG: 'Singapore',
            SX: 'Sint Maarten',
            SH: 'St. Helena',
            MF: 'St. Martin',
            SD: 'Sudan',
            SO: 'Somalia',
            SJ: 'Svalbard & Jan Mayen',
            LK: 'Sri Lanka',
            SR: 'Suriname',
            SZ: 'Eswatini',
            SY: 'Syria',
            TJ: 'Tajikistan',
            TW: 'Taiwan',
            TZ: 'Tanzania',
            TH: 'Thailand',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trinidad & Tobago',
            TD: 'Chad',
            TN: 'Tunisia',
            TR: 'Turkey',
            TM: 'Turkmenistan',
            TC: 'Turks & Caicos Islands',
            TV: 'Tuvalu',
            UY: 'Uruguay',
            VU: 'Vanuatu',
            VA: 'Vatican City',
            VE: 'Venezuela',
            GB: 'United Kingdom',
            AE: 'United Arab Emirates',
            US: 'United States',
            VN: 'Vietnam',
            WF: 'Wallis & Futuna',
            EH: 'Western Sahara',
            BY: 'Belarus',
            ZM: 'Zambia',
            ZW: 'Zimbabwe',
            ZA: 'South Africa',
            GS: 'South Georgia & South Sandwich Islands',
            KR: 'South Korea',
            SS: 'South Sudan',
            AX: 'Åland Islands',
        },
    },
    // German
    de: {
        nationalities: {
            default: 'Wählen Sie eine Nationalität',
            LU: 'Luxemburg',
            BE: 'Belgien',
            BG: 'Bulgarien',
            CY: 'Zypern',
            DK: 'Dänemark',
            DE: 'Deutschland',
            EE: 'Estland',
            FI: 'Finnland',
            FR: 'Frankreich',
            GR: 'Griechenland',
            HU: 'Ungarn',
            IE: 'Irland',
            IT: 'Italien',
            HR: 'Kroatien',
            LV: 'Lettland',
            LT: 'Litauen',
            MT: 'Malta',
            NL: 'Niederlande',
            AT: 'Österreich',
            PL: 'Polen',
            PT: 'Portugal',
            RO: 'Rumänien',
            SI: 'Slowenien',
            SK: 'Slowakei',
            ES: 'Spanien',
            CZ: 'Tschechien',
            SE: 'Schweden',
            CH: 'Schweiz',
            AF: 'Afghanistan',
            AL: 'Albanien',
            DZ: 'Algerien',
            AS: 'Amerikanisch-Samoa',
            VI: 'Amerikanische Jungferninseln',
            AD: 'Andorra',
            AO: 'Angola',
            AI: 'Anguilla',
            AQ: 'Antarktis',
            AG: 'Antigua und Barbuda',
            AR: 'Argentinien',
            AM: 'Armenien',
            AW: 'Aruba',
            AU: 'Australien',
            AZ: 'Aserbaidschan',
            BS: 'Bahamas',
            BH: 'Bahrain',
            BD: 'Bangladesch',
            BB: 'Barbados',
            BZ: 'Belize',
            BJ: 'Benin',
            BM: 'Bermuda',
            BT: 'Bhutan',
            BO: 'Bolivien',
            BQ: 'Karibische Niederlande',
            BA: 'Bosnien und Herzegowina',
            BW: 'Botsuana',
            BV: 'Bouvetinsel',
            BR: 'Brasilien',
            IO: 'Britisches Territorium im Indischen Ozean',
            VG: 'Britische Jungferninseln',
            BN: 'Brunei Darussalam',
            BF: 'Burkina Faso',
            BI: 'Burundi',
            KH: 'Kambodscha',
            CA: 'Kanada',
            CF: 'Zentralafrikanische Republik',
            CL: 'Chile',
            CN: 'China',
            CX: 'Weihnachtsinsel',
            CC: 'Kokosinseln',
            CO: 'Kolumbien',
            KM: 'Komoren',
            CG: 'Kongo-Brazzaville',
            CD: 'Kongo-Kinshasa',
            CK: 'Cookinseln',
            CR: 'Costa Rica',
            CU: 'Kuba',
            CW: 'Curaçao',
            DJ: 'Dschibuti',
            DM: 'Dominica',
            DO: 'Dominikanische Republik',
            EC: 'Ecuador',
            EG: 'Ägypten',
            SV: 'El Salvador',
            GQ: 'Äquatorialguinea',
            ER: 'Eritrea',
            ET: 'Äthiopien',
            FO: 'Färöer',
            FK: 'Falklandinseln',
            FJ: 'Fidschi',
            PH: 'Philippinen',
            GF: 'Französisch-Guayana',
            PF: 'Französisch-Polynesien',
            TF: 'Französische Süd- und Antarktisgebiete',
            GA: 'Gabun',
            GM: 'Gambia',
            GE: 'Georgien',
            GH: 'Ghana',
            GI: 'Gibraltar',
            GD: 'Grenada',
            GL: 'Grönland',
            GP: 'Guadeloupe',
            GU: 'Guam',
            GT: 'Guatemala',
            GG: 'Guernsey',
            GN: 'Guinea',
            GW: 'Guinea-Bissau',
            GY: 'Guyana',
            HT: 'Haiti',
            HM: 'Heard und McDonaldinseln',
            HN: 'Honduras',
            HK: 'Sonderverwaltungsregion Hongkong',
            IS: 'Island',
            IN: 'Indien',
            ID: 'Indonesien',
            IQ: 'Irak',
            IR: 'Iran',
            IL: 'Israel',
            CI: 'Côte d’Ivoire',
            JM: 'Jamaika',
            JP: 'Japan',
            YE: 'Jemen',
            JE: 'Jersey',
            JO: 'Jordanien',
            KY: 'Kaimaninseln',
            CV: 'Cabo Verde',
            CM: 'Kamerun',
            KZ: 'Kasachstan',
            KE: 'Kenia',
            KG: 'Kirgisistan',
            KI: 'Kiribati',
            UM: 'Amerikanische Überseeinseln',
            KW: 'Kuwait',
            LA: 'Laos',
            LS: 'Lesotho',
            LB: 'Libanon',
            LR: 'Liberia',
            LY: 'Libyen',
            LI: 'Liechtenstein',
            MO: 'Sonderverwaltungsregion Macau',
            MK: 'Nordmazedonien',
            MG: 'Madagaskar',
            MW: 'Malawi',
            MV: 'Malediven',
            MY: 'Malaysia',
            ML: 'Mali',
            IM: 'Isle of Man',
            MA: 'Marokko',
            MH: 'Marshallinseln',
            MQ: 'Martinique',
            MR: 'Mauretanien',
            MU: 'Mauritius',
            YT: 'Mayotte',
            MX: 'Mexiko',
            FM: 'Mikronesien',
            MD: 'Republik Moldau',
            MC: 'Monaco',
            MN: 'Mongolei',
            ME: 'Montenegro',
            MS: 'Montserrat',
            MZ: 'Mosambik',
            MM: 'Myanmar',
            NA: 'Namibia',
            NR: 'Nauru',
            NP: 'Nepal',
            NI: 'Nicaragua',
            NC: 'Neukaledonien',
            NZ: 'Neuseeland',
            NE: 'Niger',
            NG: 'Nigeria',
            NU: 'Niue',
            KP: 'Nordkorea',
            MP: 'Nördliche Marianen',
            NO: 'Norwegen',
            NF: 'Norfolkinsel',
            UG: 'Uganda',
            UA: 'Ukraine',
            UZ: 'Usbekistan',
            OM: 'Oman',
            TL: 'Timor-Leste',
            PK: 'Pakistan',
            PW: 'Palau',
            PA: 'Panama',
            PG: 'Papua-Neuguinea',
            PY: 'Paraguay',
            PE: 'Peru',
            PN: 'Pitcairninseln',
            PR: 'Puerto Rico',
            QA: 'Katar',
            RU: 'Russland',
            RW: 'Ruanda',
            RE: 'Réunion',
            KN: 'St. Kitts und Nevis',
            LC: 'St. Lucia',
            VC: 'St. Vincent und die Grenadinen',
            BL: 'St. Barthélemy',
            PM: 'St. Pierre und Miquelon',
            SB: 'Salomonen',
            WS: 'Samoa',
            SM: 'San Marino',
            ST: 'São Tomé und Príncipe',
            SA: 'Saudi-Arabien',
            SN: 'Senegal',
            RS: 'Serbien',
            SC: 'Seychellen',
            SL: 'Sierra Leone',
            SG: 'Singapur',
            SX: 'Sint Maarten',
            SH: 'St. Helena',
            MF: 'St. Martin',
            SD: 'Sudan',
            SO: 'Somalia',
            SJ: 'Spitzbergen und Jan Mayen',
            LK: 'Sri Lanka',
            SR: 'Suriname',
            SZ: 'Eswatini',
            SY: 'Syrien',
            TJ: 'Tadschikistan',
            TW: 'Taiwan',
            TZ: 'Tansania',
            TH: 'Thailand',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trinidad und Tobago',
            TD: 'Tschad',
            TN: 'Tunesien',
            TR: 'Türkei',
            TM: 'Turkmenistan',
            TC: 'Turks- und Caicosinseln',
            TV: 'Tuvalu',
            UY: 'Uruguay',
            VU: 'Vanuatu',
            VA: 'Vatikanstadt',
            VE: 'Venezuela',
            GB: 'Vereinigtes Königreich',
            AE: 'Vereinigte Arabische Emirate',
            US: 'Vereinigte Staaten',
            VN: 'Vietnam',
            WF: 'Wallis und Futuna',
            EH: 'Westsahara',
            BY: 'Belarus',
            ZM: 'Sambia',
            ZW: 'Simbabwe',
            ZA: 'Südafrika',
            GS: 'Südgeorgien und die Südlichen Sandwichinseln',
            KR: 'Südkorea',
            SS: 'Südsudan',
            AX: 'Ålandinseln',
        },
    },
    // French
    fr: {
        nationalities: {
            default: 'Sélectionnez une nationalité',
            LU: 'Luxembourg',
            BE: 'Belgique',
            BG: 'Bulgarie',
            CY: 'Chypre',
            DK: 'Danemark',
            DE: 'Allemagne',
            EE: 'Estonie',
            FI: 'Finlande',
            FR: 'France',
            GR: 'Grèce',
            HU: 'Hongrie',
            IE: 'Irlande',
            IT: 'Italie',
            HR: 'Croatie',
            LV: 'Lettonie',
            LT: 'Lituanie',
            MT: 'Malte',
            NL: 'Pays-Bas',
            AT: 'Autriche',
            PL: 'Pologne',
            PT: 'Portugal',
            RO: 'Roumanie',
            SI: 'Slovénie',
            SK: 'Slovaquie',
            ES: 'Espagne',
            CZ: 'Tchéquie',
            SE: 'Suède',
            CH: 'Suisse',
            AF: 'Afghanistan',
            AL: 'Albanie',
            DZ: 'Algérie',
            AS: 'Samoa américaines',
            VI: 'Îles Vierges des États-Unis',
            AD: 'Andorre',
            AO: 'Angola',
            AI: 'Anguilla',
            AQ: 'Antarctique',
            AG: 'Antigua-et-Barbuda',
            AR: 'Argentine',
            AM: 'Arménie',
            AW: 'Aruba',
            AU: 'Australie',
            AZ: 'Azerbaïdjan',
            BS: 'Bahamas',
            BH: 'Bahreïn',
            BD: 'Bangladesh',
            BB: 'Barbade',
            BZ: 'Belize',
            BJ: 'Bénin',
            BM: 'Bermudes',
            BT: 'Bhoutan',
            BO: 'Bolivie',
            BQ: 'Pays-Bas caribéens',
            BA: 'Bosnie-Herzégovine',
            BW: 'Botswana',
            BV: 'Île Bouvet',
            BR: 'Brésil',
            IO: 'Territoire britannique de l’océan Indien',
            VG: 'Îles Vierges britanniques',
            BN: 'Brunei',
            BF: 'Burkina Faso',
            BI: 'Burundi',
            KH: 'Cambodge',
            CA: 'Canada',
            CF: 'République centrafricaine',
            CL: 'Chili',
            CN: 'Chine',
            CX: 'Île Christmas',
            CC: 'Îles Cocos',
            CO: 'Colombie',
            KM: 'Comores',
            CG: 'Congo-Brazzaville',
            CD: 'Congo-Kinshasa',
            CK: 'Îles Cook',
            CR: 'Costa Rica',
            CU: 'Cuba',
            CW: 'Curaçao',
            DJ: 'Djibouti',
            DM: 'Dominique',
            DO: 'République dominicaine',
            EC: 'Équateur',
            EG: 'Égypte',
            SV: 'Salvador',
            GQ: 'Guinée équatoriale',
            ER: 'Érythrée',
            ET: 'Éthiopie',
            FO: 'Îles Féroé',
            FK: 'Îles Malouines',
            FJ: 'Fidji',
            PH: 'Philippines',
            GF: 'Guyane française',
            PF: 'Polynésie française',
            TF: 'Terres australes françaises',
            GA: 'Gabon',
            GM: 'Gambie',
            GE: 'Géorgie',
            GH: 'Ghana',
            GI: 'Gibraltar',
            GD: 'Grenade',
            GL: 'Groenland',
            GP: 'Guadeloupe',
            GU: 'Guam',
            GT: 'Guatemala',
            GG: 'Guernesey',
            GN: 'Guinée',
            GW: 'Guinée-Bissau',
            GY: 'Guyana',
            HT: 'Haïti',
            HM: 'Îles Heard-et-MacDonald',
            HN: 'Honduras',
            HK: 'R.A.S. chinoise de Hong Kong',
            IS: 'Islande',
            IN: 'Inde',
            ID: 'Indonésie',
            IQ: 'Irak',
            IR: 'Iran',
            IL: 'Israël',
            CI: 'Côte d’Ivoire',
            JM: 'Jamaïque',
            JP: 'Japon',
            YE: 'Yémen',
            JE: 'Jersey',
            JO: 'Jordanie',
            KY: 'Îles Caïmans',
            CV: 'Cap-Vert',
            CM: 'Cameroun',
            KZ: 'Kazakhstan',
            KE: 'Kenya',
            KG: 'Kirghizstan',
            KI: 'Kiribati',
            UM: 'Îles mineures éloignées des États-Unis',
            KW: 'Koweït',
            LA: 'Laos',
            LS: 'Lesotho',
            LB: 'Liban',
            LR: 'Liberia',
            LY: 'Libye',
            LI: 'Liechtenstein',
            MO: 'R.A.S. chinoise de Macao',
            MK: 'Macédoine du Nord',
            MG: 'Madagascar',
            MW: 'Malawi',
            MV: 'Maldives',
            MY: 'Malaisie',
            ML: 'Mali',
            IM: 'Île de Man',
            MA: 'Maroc',
            MH: 'Îles Marshall',
            MQ: 'Martinique',
            MR: 'Mauritanie',
            MU: 'Maurice',
            YT: 'Mayotte',
            MX: 'Mexique',
            FM: 'Micronésie',
            MD: 'Moldavie',
            MC: 'Monaco',
            MN: 'Mongolie',
            ME: 'Monténégro',
            MS: 'Montserrat',
            MZ: 'Mozambique',
            MM: 'Myanmar (Birmanie)',
            NA: 'Namibie',
            NR: 'Nauru',
            NP: 'Népal',
            NI: 'Nicaragua',
            NC: 'Nouvelle-Calédonie',
            NZ: 'Nouvelle-Zélande',
            NE: 'Niger',
            NG: 'Nigeria',
            NU: 'Niue',
            KP: 'Corée du Nord',
            MP: 'Îles Mariannes du Nord',
            NO: 'Norvège',
            NF: 'Île Norfolk',
            UG: 'Ouganda',
            UA: 'Ukraine',
            UZ: 'Ouzbékistan',
            OM: 'Oman',
            TL: 'Timor oriental',
            PK: 'Pakistan',
            PW: 'Palaos',
            PA: 'Panama',
            PG: 'Papouasie-Nouvelle-Guinée',
            PY: 'Paraguay',
            PE: 'Pérou',
            PN: 'Îles Pitcairn',
            PR: 'Porto Rico',
            QA: 'Qatar',
            RU: 'Russie',
            RW: 'Rwanda',
            RE: 'La Réunion',
            KN: 'Saint-Christophe-et-Niévès',
            LC: 'Sainte-Lucie',
            VC: 'Saint-Vincent-et-les Grenadines',
            BL: 'Saint-Barthélemy',
            PM: 'Saint-Pierre-et-Miquelon',
            SB: 'Îles Salomon',
            WS: 'Samoa',
            SM: 'Saint-Marin',
            ST: 'Sao Tomé-et-Principe',
            SA: 'Arabie saoudite',
            SN: 'Sénégal',
            RS: 'Serbie',
            SC: 'Seychelles',
            SL: 'Sierra Leone',
            SG: 'Singapour',
            SX: 'Saint-Martin (partie néerlandaise)',
            SH: 'Sainte-Hélène',
            MF: 'Saint-Martin',
            SD: 'Soudan',
            SO: 'Somalie',
            SJ: 'Svalbard et Jan Mayen',
            LK: 'Sri Lanka',
            SR: 'Suriname',
            SZ: 'Eswatini',
            SY: 'Syrie',
            TJ: 'Tadjikistan',
            TW: 'Taïwan',
            TZ: 'Tanzanie',
            TH: 'Thaïlande',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trinité-et-Tobago',
            TD: 'Tchad',
            TN: 'Tunisie',
            TR: 'Turquie',
            TM: 'Turkménistan',
            TC: 'Îles Turques-et-Caïques',
            TV: 'Tuvalu',
            UY: 'Uruguay',
            VU: 'Vanuatu',
            VA: 'État de la Cité du Vatican',
            VE: 'Venezuela',
            GB: 'Royaume-Uni',
            AE: 'Émirats arabes unis',
            US: 'États-Unis',
            VN: 'Viêt Nam',
            WF: 'Wallis-et-Futuna',
            EH: 'Sahara occidental',
            BY: 'Biélorussie',
            ZM: 'Zambie',
            ZW: 'Zimbabwe',
            ZA: 'Afrique du Sud',
            GS: 'Géorgie du Sud-et-les Îles Sandwich du Sud',
            KR: 'Corée du Sud',
            SS: 'Soudan du Sud',
            AX: 'Îles Åland',
        },
    },
    // Italian
    it: {
        nationalities: {
            default: 'Seleziona una nazionalità',
            LU: 'Lussemburgo',
            BE: 'Belgio',
            BG: 'Bulgaria',
            CY: 'Cipro',
            DK: 'Danimarca',
            DE: 'Germania',
            EE: 'Estonia',
            FI: 'Finlandia',
            FR: 'Francia',
            GR: 'Grecia',
            HU: 'Ungheria',
            IE: 'Irlanda',
            IT: 'Italia',
            HR: 'Croazia',
            LV: 'Lettonia',
            LT: 'Lituania',
            MT: 'Malta',
            NL: 'Paesi Bassi',
            AT: 'Austria',
            PL: 'Polonia',
            PT: 'Portogallo',
            RO: 'Romania',
            SI: 'Slovenia',
            SK: 'Slovacchia',
            ES: 'Spagna',
            CZ: 'Cechia',
            SE: 'Svezia',
            CH: 'Svizzera',
            AF: 'Afghanistan',
            AL: 'Albania',
            DZ: 'Algeria',
            AS: 'Samoa americane',
            VI: 'Isole Vergini Americane',
            AD: 'Andorra',
            AO: 'Angola',
            AI: 'Anguilla',
            AQ: 'Antartide',
            AG: 'Antigua e Barbuda',
            AR: 'Argentina',
            AM: 'Armenia',
            AW: 'Aruba',
            AU: 'Australia',
            AZ: 'Azerbaigian',
            BS: 'Bahamas',
            BH: 'Bahrein',
            BD: 'Bangladesh',
            BB: 'Barbados',
            BZ: 'Belize',
            BJ: 'Benin',
            BM: 'Bermuda',
            BT: 'Bhutan',
            BO: 'Bolivia',
            BQ: 'Caraibi olandesi',
            BA: 'Bosnia ed Erzegovina',
            BW: 'Botswana',
            BV: 'Isola Bouvet',
            BR: 'Brasile',
            IO: 'Territorio britannico dell’Oceano Indiano',
            VG: 'Isole Vergini Britanniche',
            BN: 'Brunei',
            BF: 'Burkina Faso',
            BI: 'Burundi',
            KH: 'Cambogia',
            CA: 'Canada',
            CF: 'Repubblica Centrafricana',
            CL: 'Cile',
            CN: 'Cina',
            CX: 'Isola Christmas',
            CC: 'Isole Cocos (Keeling)',
            CO: 'Colombia',
            KM: 'Comore',
            CG: 'Congo-Brazzaville',
            CD: 'Congo - Kinshasa',
            CK: 'Isole Cook',
            CR: 'Costa Rica',
            CU: 'Cuba',
            CW: 'Curaçao',
            DJ: 'Gibuti',
            DM: 'Dominica',
            DO: 'Repubblica Dominicana',
            EC: 'Ecuador',
            EG: 'Egitto',
            SV: 'El Salvador',
            GQ: 'Guinea Equatoriale',
            ER: 'Eritrea',
            ET: 'Etiopia',
            FO: 'Isole Fær Øer',
            FK: 'Isole Falkland',
            FJ: 'Figi',
            PH: 'Filippine',
            GF: 'Guyana Francese',
            PF: 'Polinesia francese',
            TF: 'Terre australi francesi',
            GA: 'Gabon',
            GM: 'Gambia',
            GE: 'Georgia',
            GH: 'Ghana',
            GI: 'Gibilterra',
            GD: 'Grenada',
            GL: 'Groenlandia',
            GP: 'Guadalupa',
            GU: 'Guam',
            GT: 'Guatemala',
            GG: 'Guernsey',
            GN: 'Guinea',
            GW: 'Guinea-Bissau',
            GY: 'Guyana',
            HT: 'Haiti',
            HM: 'Isole Heard e McDonald',
            HN: 'Honduras',
            HK: 'RAS di Hong Kong',
            IS: 'Islanda',
            IN: 'India',
            ID: 'Indonesia',
            IQ: 'Iraq',
            IR: 'Iran',
            IL: 'Israele',
            CI: 'Costa d’Avorio',
            JM: 'Giamaica',
            JP: 'Giappone',
            YE: 'Yemen',
            JE: 'Jersey',
            JO: 'Giordania',
            KY: 'Isole Cayman',
            CV: 'Capo Verde',
            CM: 'Camerun',
            KZ: 'Kazakistan',
            KE: 'Kenya',
            KG: 'Kirghizistan',
            KI: 'Kiribati',
            UM: 'Isole Minori Esterne degli Stati Uniti',
            KW: 'Kuwait',
            LA: 'Laos',
            LS: 'Lesotho',
            LB: 'Libano',
            LR: 'Liberia',
            LY: 'Libia',
            LI: 'Liechtenstein',
            MO: 'RAS di Macao',
            MK: 'Macedonia del Nord',
            MG: 'Madagascar',
            MW: 'Malawi',
            MV: 'Maldive',
            MY: 'Malaysia',
            ML: 'Mali',
            IM: 'Isola di Man',
            MA: 'Marocco',
            MH: 'Isole Marshall',
            MQ: 'Martinica',
            MR: 'Mauritania',
            MU: 'Mauritius',
            YT: 'Mayotte',
            MX: 'Messico',
            FM: 'Micronesia',
            MD: 'Moldavia',
            MC: 'Monaco',
            MN: 'Mongolia',
            ME: 'Montenegro',
            MS: 'Montserrat',
            MZ: 'Mozambico',
            MM: 'Myanmar (Birmania)',
            NA: 'Namibia',
            NR: 'Nauru',
            NP: 'Nepal',
            NI: 'Nicaragua',
            NC: 'Nuova Caledonia',
            NZ: 'Nuova Zelanda',
            NE: 'Niger',
            NG: 'Nigeria',
            NU: 'Niue',
            KP: 'Corea del Nord',
            MP: 'Isole Marianne settentrionali',
            NO: 'Norvegia',
            NF: 'Isola Norfolk',
            UG: 'Uganda',
            UA: 'Ucraina',
            UZ: 'Uzbekistan',
            OM: 'Oman',
            TL: 'Timor Est',
            PK: 'Pakistan',
            PW: 'Palau',
            PA: 'Panama',
            PG: 'Papua Nuova Guinea',
            PY: 'Paraguay',
            PE: 'Perù',
            PN: 'Isole Pitcairn',
            PR: 'Portorico',
            QA: 'Qatar',
            RU: 'Russia',
            RW: 'Ruanda',
            RE: 'Riunione',
            KN: 'Saint Kitts e Nevis',
            LC: 'Saint Lucia',
            VC: 'Saint Vincent e Grenadine',
            BL: 'Saint-Barthélemy',
            PM: 'Saint-Pierre e Miquelon',
            SB: 'Isole Salomone',
            WS: 'Samoa',
            SM: 'San Marino',
            ST: 'São Tomé e Príncipe',
            SA: 'Arabia Saudita',
            SN: 'Senegal',
            RS: 'Serbia',
            SC: 'Seychelles',
            SL: 'Sierra Leone',
            SG: 'Singapore',
            SX: 'Sint Maarten',
            SH: 'Sant’Elena',
            MF: 'Saint Martin',
            SD: 'Sudan',
            SO: 'Somalia',
            SJ: 'Svalbard e Jan Mayen',
            LK: 'Sri Lanka',
            SR: 'Suriname',
            SZ: 'eSwatini',
            SY: 'Siria',
            TJ: 'Tagikistan',
            TW: 'Taiwan',
            TZ: 'Tanzania',
            TH: 'Thailandia',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trinidad e Tobago',
            TD: 'Ciad',
            TN: 'Tunisia',
            TR: 'Turchia',
            TM: 'Turkmenistan',
            TC: 'Isole Turks e Caicos',
            TV: 'Tuvalu',
            UY: 'Uruguay',
            VU: 'Vanuatu',
            VA: 'Città del Vaticano',
            VE: 'Venezuela',
            GB: 'Regno Unito',
            AE: 'Emirati Arabi Uniti',
            US: 'Stati Uniti',
            VN: 'Vietnam',
            WF: 'Wallis e Futuna',
            EH: 'Sahara occidentale',
            BY: 'Bielorussia',
            ZM: 'Zambia',
            ZW: 'Zimbabwe',
            ZA: 'Sudafrica',
            GS: 'Georgia del Sud e Sandwich Australi',
            KR: 'Corea del Sud',
            SS: 'Sud Sudan',
            AX: 'Isole Åland',
        },
    },
    // Spanish
    es: {
        nationalities: {
            default: 'Selecciona una nacionalidad',
            LU: 'Luxemburgo',
            BE: 'Bélgica',
            BG: 'Bulgaria',
            CY: 'Chipre',
            DK: 'Dinamarca',
            DE: 'Alemania',
            EE: 'Estonia',
            FI: 'Finlandia',
            FR: 'Francia',
            GR: 'Grecia',
            HU: 'Hungría',
            IE: 'Irlanda',
            IT: 'Italia',
            HR: 'Croacia',
            LV: 'Letonia',
            LT: 'Lituania',
            MT: 'Malta',
            NL: 'Países Bajos',
            AT: 'Austria',
            PL: 'Polonia',
            PT: 'Portugal',
            RO: 'Rumanía',
            SI: 'Eslovenia',
            SK: 'Eslovaquia',
            ES: 'España',
            CZ: 'Chequia',
            SE: 'Suecia',
            CH: 'Suiza',
            AF: 'Afganistán',
            AL: 'Albania',
            DZ: 'Argelia',
            AS: 'Samoa Americana',
            VI: 'Islas Vírgenes de EE. UU.',
            AD: 'Andorra',
            AO: 'Angola',
            AI: 'Anguila',
            AQ: 'Antártida',
            AG: 'Antigua y Barbuda',
            AR: 'Argentina',
            AM: 'Armenia',
            AW: 'Aruba',
            AU: 'Australia',
            AZ: 'Azerbaiyán',
            BS: 'Bahamas',
            BH: 'Baréin',
            BD: 'Bangladés',
            BB: 'Barbados',
            BZ: 'Belice',
            BJ: 'Benín',
            BM: 'Bermudas',
            BT: 'Bután',
            BO: 'Bolivia',
            BQ: 'Caribe neerlandés',
            BA: 'Bosnia y Herzegovina',
            BW: 'Botsuana',
            BV: 'Isla Bouvet',
            BR: 'Brasil',
            IO: 'Territorio Británico del Océano Índico',
            VG: 'Islas Vírgenes Británicas',
            BN: 'Brunéi',
            BF: 'Burkina Faso',
            BI: 'Burundi',
            KH: 'Camboya',
            CA: 'Canadá',
            CF: 'República Centroafricana',
            CL: 'Chile',
            CN: 'China',
            CX: 'Isla de Navidad',
            CC: 'Islas Cocos',
            CO: 'Colombia',
            KM: 'Comoras',
            CG: 'Congo',
            CD: 'República Democrática del Congo',
            CK: 'Islas Cook',
            CR: 'Costa Rica',
            CU: 'Cuba',
            CW: 'Curazao',
            DJ: 'Yibuti',
            DM: 'Dominica',
            DO: 'República Dominicana',
            EC: 'Ecuador',
            EG: 'Egipto',
            SV: 'El Salvador',
            GQ: 'Guinea Ecuatorial',
            ER: 'Eritrea',
            ET: 'Etiopía',
            FO: 'Islas Feroe',
            FK: 'Islas Malvinas',
            FJ: 'Fiyi',
            PH: 'Filipinas',
            GF: 'Guayana Francesa',
            PF: 'Polinesia Francesa',
            TF: 'Territorios Australes Franceses',
            GA: 'Gabón',
            GM: 'Gambia',
            GE: 'Georgia',
            GH: 'Ghana',
            GI: 'Gibraltar',
            GD: 'Granada',
            GL: 'Groenlandia',
            GP: 'Guadalupe',
            GU: 'Guam',
            GT: 'Guatemala',
            GG: 'Guernesey',
            GN: 'Guinea',
            GW: 'Guinea-Bisáu',
            GY: 'Guyana',
            HT: 'Haití',
            HM: 'Islas Heard y McDonald',
            HN: 'Honduras',
            HK: 'RAE de Hong Kong (China)',
            IS: 'Islandia',
            IN: 'India',
            ID: 'Indonesia',
            IQ: 'Irak',
            IR: 'Irán',
            IL: 'Israel',
            CI: 'Côte d’Ivoire',
            JM: 'Jamaica',
            JP: 'Japón',
            YE: 'Yemen',
            JE: 'Jersey',
            JO: 'Jordania',
            KY: 'Islas Caimán',
            CV: 'Cabo Verde',
            CM: 'Camerún',
            KZ: 'Kazajistán',
            KE: 'Kenia',
            KG: 'Kirguistán',
            KI: 'Kiribati',
            UM: 'Islas menores alejadas de EE. UU.',
            KW: 'Kuwait',
            LA: 'Laos',
            LS: 'Lesoto',
            LB: 'Líbano',
            LR: 'Liberia',
            LY: 'Libia',
            LI: 'Liechtenstein',
            MO: 'RAE de Macao (China)',
            MK: 'Macedonia del Norte',
            MG: 'Madagascar',
            MW: 'Malaui',
            MV: 'Maldivas',
            MY: 'Malasia',
            ML: 'Mali',
            IM: 'Isla de Man',
            MA: 'Marruecos',
            MH: 'Islas Marshall',
            MQ: 'Martinica',
            MR: 'Mauritania',
            MU: 'Mauricio',
            YT: 'Mayotte',
            MX: 'México',
            FM: 'Micronesia',
            MD: 'Moldavia',
            MC: 'Mónaco',
            MN: 'Mongolia',
            ME: 'Montenegro',
            MS: 'Montserrat',
            MZ: 'Mozambique',
            MM: 'Myanmar (Birmania)',
            NA: 'Namibia',
            NR: 'Nauru',
            NP: 'Nepal',
            NI: 'Nicaragua',
            NC: 'Nueva Caledonia',
            NZ: 'Nueva Zelanda',
            NE: 'Níger',
            NG: 'Nigeria',
            NU: 'Niue',
            KP: 'Corea del Norte',
            MP: 'Islas Marianas del Norte',
            NO: 'Noruega',
            NF: 'Isla Norfolk',
            UG: 'Uganda',
            UA: 'Ucrania',
            UZ: 'Uzbekistán',
            OM: 'Omán',
            TL: 'Timor-Leste',
            PK: 'Pakistán',
            PW: 'Palaos',
            PA: 'Panamá',
            PG: 'Papúa Nueva Guinea',
            PY: 'Paraguay',
            PE: 'Perú',
            PN: 'Islas Pitcairn',
            PR: 'Puerto Rico',
            QA: 'Catar',
            RU: 'Rusia',
            RW: 'Ruanda',
            RE: 'Reunión',
            KN: 'San Cristóbal y Nieves',
            LC: 'Santa Lucía',
            VC: 'San Vicente y las Granadinas',
            BL: 'San Bartolomé',
            PM: 'San Pedro y Miquelón',
            SB: 'Islas Salomón',
            WS: 'Samoa',
            SM: 'San Marino',
            ST: 'Santo Tomé y Príncipe',
            SA: 'Arabia Saudí',
            SN: 'Senegal',
            RS: 'Serbia',
            SC: 'Seychelles',
            SL: 'Sierra Leona',
            SG: 'Singapur',
            SX: 'Sint Maarten',
            SH: 'Santa Elena',
            MF: 'San Martín',
            SD: 'Sudán',
            SO: 'Somalia',
            SJ: 'Svalbard y Jan Mayen',
            LK: 'Sri Lanka',
            SR: 'Surinam',
            SZ: 'Esuatini',
            SY: 'Siria',
            TJ: 'Tayikistán',
            TW: 'Taiwán',
            TZ: 'Tanzania',
            TH: 'Tailandia',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trinidad y Tobago',
            TD: 'Chad',
            TN: 'Túnez',
            TR: 'Turquía',
            TM: 'Turkmenistán',
            TC: 'Islas Turcas y Caicos',
            TV: 'Tuvalu',
            UY: 'Uruguay',
            VU: 'Vanuatu',
            VA: 'Ciudad del Vaticano',
            VE: 'Venezuela',
            GB: 'Reino Unido',
            AE: 'Emiratos Árabes Unidos',
            US: 'Estados Unidos',
            VN: 'Vietnam',
            WF: 'Wallis y Futuna',
            EH: 'Sáhara Occidental',
            BY: 'Bielorrusia',
            ZM: 'Zambia',
            ZW: 'Zimbabue',
            ZA: 'Sudáfrica',
            GS: 'Islas Georgia del Sur y Sandwich del Sur',
            KR: 'Corea del Sur',
            SS: 'Sudán del Sur',
            AX: 'Islas Aland',
        },
    },
    // Portuguese
    pt: {
        nationalities: {
            default: 'Selecione uma nacionalidade',
            LU: 'Luxemburgo',
            BE: 'Bélgica',
            BG: 'Bulgária',
            CY: 'Chipre',
            DK: 'Dinamarca',
            DE: 'Alemanha',
            EE: 'Estônia',
            FI: 'Finlândia',
            FR: 'França',
            GR: 'Grécia',
            HU: 'Hungria',
            IE: 'Irlanda',
            IT: 'Itália',
            HR: 'Croácia',
            LV: 'Letônia',
            LT: 'Lituânia',
            MT: 'Malta',
            NL: 'Países Baixos',
            AT: 'Áustria',
            PL: 'Polônia',
            PT: 'Portugal',
            RO: 'Romênia',
            SI: 'Eslovênia',
            SK: 'Eslováquia',
            ES: 'Espanha',
            CZ: 'Tchéquia',
            SE: 'Suécia',
            CH: 'Suíça',
            AF: 'Afeganistão',
            AL: 'Albânia',
            DZ: 'Argélia',
            AS: 'Samoa Americana',
            VI: 'Ilhas Virgens Americanas',
            AD: 'Andorra',
            AO: 'Angola',
            AI: 'Anguila',
            AQ: 'Antártida',
            AG: 'Antígua e Barbuda',
            AR: 'Argentina',
            AM: 'Armênia',
            AW: 'Aruba',
            AU: 'Austrália',
            AZ: 'Azerbaijão',
            BS: 'Bahamas',
            BH: 'Barein',
            BD: 'Bangladesh',
            BB: 'Barbados',
            BZ: 'Belize',
            BJ: 'Benin',
            BM: 'Bermudas',
            BT: 'Butão',
            BO: 'Bolívia',
            BQ: 'Países Baixos Caribenhos',
            BA: 'Bósnia e Herzegovina',
            BW: 'Botsuana',
            BV: 'Ilha Bouvet',
            BR: 'Brasil',
            IO: 'Território Britânico do Oceano Índico',
            VG: 'Ilhas Virgens Britânicas',
            BN: 'Brunei',
            BF: 'Burquina Faso',
            BI: 'Burundi',
            KH: 'Camboja',
            CA: 'Canadá',
            CF: 'República Centro-Africana',
            CL: 'Chile',
            CN: 'China',
            CX: 'Ilha Christmas',
            CC: 'Ilhas Cocos (Keeling)',
            CO: 'Colômbia',
            KM: 'Comores',
            CG: 'República do Congo',
            CD: 'Congo - Kinshasa',
            CK: 'Ilhas Cook',
            CR: 'Costa Rica',
            CU: 'Cuba',
            CW: 'Curaçao',
            DJ: 'Djibuti',
            DM: 'Dominica',
            DO: 'República Dominicana',
            EC: 'Equador',
            EG: 'Egito',
            SV: 'El Salvador',
            GQ: 'Guiné Equatorial',
            ER: 'Eritreia',
            ET: 'Etiópia',
            FO: 'Ilhas Faroé',
            FK: 'Ilhas Malvinas',
            FJ: 'Fiji',
            PH: 'Filipinas',
            GF: 'Guiana Francesa',
            PF: 'Polinésia Francesa',
            TF: 'Territórios Franceses do Sul',
            GA: 'Gabão',
            GM: 'Gâmbia',
            GE: 'Geórgia',
            GH: 'Gana',
            GI: 'Gibraltar',
            GD: 'Granada',
            GL: 'Groenlândia',
            GP: 'Guadalupe',
            GU: 'Guam',
            GT: 'Guatemala',
            GG: 'Guernsey',
            GN: 'Guiné',
            GW: 'Guiné-Bissau',
            GY: 'Guiana',
            HT: 'Haiti',
            HM: 'Ilhas Heard e McDonald',
            HN: 'Honduras',
            HK: 'Hong Kong, RAE da China',
            IS: 'Islândia',
            IN: 'Índia',
            ID: 'Indonésia',
            IQ: 'Iraque',
            IR: 'Irã',
            IL: 'Israel',
            CI: 'Costa do Marfim',
            JM: 'Jamaica',
            JP: 'Japão',
            YE: 'Iêmen',
            JE: 'Jersey',
            JO: 'Jordânia',
            KY: 'Ilhas Cayman',
            CV: 'Cabo Verde',
            CM: 'Camarões',
            KZ: 'Cazaquistão',
            KE: 'Quênia',
            KG: 'Quirguistão',
            KI: 'Quiribati',
            UM: 'Ilhas Menores Distantes dos EUA',
            KW: 'Kuwait',
            LA: 'Laos',
            LS: 'Lesoto',
            LB: 'Líbano',
            LR: 'Libéria',
            LY: 'Líbia',
            LI: 'Liechtenstein',
            MO: 'Macau, RAE da China',
            MK: 'Macedônia do Norte',
            MG: 'Madagascar',
            MW: 'Malaui',
            MV: 'Maldivas',
            MY: 'Malásia',
            ML: 'Mali',
            IM: 'Ilha de Man',
            MA: 'Marrocos',
            MH: 'Ilhas Marshall',
            MQ: 'Martinica',
            MR: 'Mauritânia',
            MU: 'Maurício',
            YT: 'Mayotte',
            MX: 'México',
            FM: 'Micronésia',
            MD: 'Moldávia',
            MC: 'Mônaco',
            MN: 'Mongólia',
            ME: 'Montenegro',
            MS: 'Montserrat',
            MZ: 'Moçambique',
            MM: 'Mianmar (Birmânia)',
            NA: 'Namíbia',
            NR: 'Nauru',
            NP: 'Nepal',
            NI: 'Nicarágua',
            NC: 'Nova Caledônia',
            NZ: 'Nova Zelândia',
            NE: 'Níger',
            NG: 'Nigéria',
            NU: 'Niue',
            KP: 'Coreia do Norte',
            MP: 'Ilhas Marianas do Norte',
            NO: 'Noruega',
            NF: 'Ilha Norfolk',
            UG: 'Uganda',
            UA: 'Ucrânia',
            UZ: 'Uzbequistão',
            OM: 'Omã',
            TL: 'Timor-Leste',
            PK: 'Paquistão',
            PW: 'Palau',
            PA: 'Panamá',
            PG: 'Papua-Nova Guiné',
            PY: 'Paraguai',
            PE: 'Peru',
            PN: 'Ilhas Pitcairn',
            PR: 'Porto Rico',
            QA: 'Catar',
            RU: 'Rússia',
            RW: 'Ruanda',
            RE: 'Reunião',
            KN: 'São Cristóvão e Névis',
            LC: 'Santa Lúcia',
            VC: 'São Vicente e Granadinas',
            BL: 'São Bartolomeu',
            PM: 'São Pedro e Miquelão',
            SB: 'Ilhas Salomão',
            WS: 'Samoa',
            SM: 'San Marino',
            ST: 'São Tomé e Príncipe',
            SA: 'Arábia Saudita',
            SN: 'Senegal',
            RS: 'Sérvia',
            SC: 'Seicheles',
            SL: 'Serra Leoa',
            SG: 'Singapura',
            SX: 'Sint Maarten',
            SH: 'Santa Helena',
            MF: 'São Martinho',
            SD: 'Sudão',
            SO: 'Somália',
            SJ: 'Svalbard e Jan Mayen',
            LK: 'Sri Lanka',
            SR: 'Suriname',
            SZ: 'Essuatíni',
            SY: 'Síria',
            TJ: 'Tadjiquistão',
            TW: 'Taiwan',
            TZ: 'Tanzânia',
            TH: 'Tailândia',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trinidad e Tobago',
            TD: 'Chade',
            TN: 'Tunísia',
            TR: 'Turquia',
            TM: 'Turcomenistão',
            TC: 'Ilhas Turcas e Caicos',
            TV: 'Tuvalu',
            UY: 'Uruguai',
            VU: 'Vanuatu',
            VA: 'Cidade do Vaticano',
            VE: 'Venezuela',
            GB: 'Reino Unido',
            AE: 'Emirados Árabes Unidos',
            US: 'Estados Unidos',
            VN: 'Vietnã',
            WF: 'Wallis e Futuna',
            EH: 'Saara Ocidental',
            BY: 'Bielorrússia',
            ZM: 'Zâmbia',
            ZW: 'Zimbábue',
            ZA: 'África do Sul',
            GS: 'Ilhas Geórgia do Sul e Sandwich do Sul',
            KR: 'Coreia do Sul',
            SS: 'Sudão do Sul',
            AX: 'Ilhas Aland',
        },
    },
};
